import { Controller } from "stimulus";

const COIN_INSIGHT_BREAKDOWN_MODAL_ID = "coin_insight_breakdown";

export default class extends Controller {
  async show(e) {
    // Use document.querySelector because there are multiple usages of this controller, but only 1 coin_insight_breakdown modal;
    // One instance is attached to the coin_insights modal, and the other instance is attached to the summary view on the coin page.
    const breakdownContainerTarget = document.querySelector(".gecko-coin-insight-breakdown-container")
    const breakdownSkeletonTarget = document.querySelector(".gecko-coin-insight-breakdown-skeleton")

    if (!breakdownContainerTarget || !breakdownSkeletonTarget) {
      console.error("Coin insight breakdown container/skeleton target not found.")
      return;
    }

    breakdownContainerTarget.classList.add("tw-hidden");
    breakdownSkeletonTarget.classList.remove("tw-hidden");
    breakdownContainerTarget.innerHTML = "";
    Modal.show(COIN_INSIGHT_BREAKDOWN_MODAL_ID);


    const url = new URL(e.currentTarget.dataset.url);
    const response = await fetch(url);

    breakdownContainerTarget.innerHTML = response.ok ? await response.text() : I18n.t("labels.generic_error");
    breakdownSkeletonTarget.classList.add("tw-hidden");
    breakdownContainerTarget.classList.remove("tw-hidden");
  }
}
